exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-13{position:relative;width:100%;height:100%}.dv-border-box-13 .dv-border-svg-container{position:absolute;width:100%;height:100%;top:0;left:0}.dv-border-box-13 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox13/src/main.css
// module id = 1071
// module chunks = 45